<ng-container [formGroup]="form">
  <mat-form-field appearance="outline">
    <mat-label i18n="@@Email">Email</mat-label>
    <input
      matInput
      required
      formControlName="email"
      name="email"
      type="email"
      (keydown)="onSubmit($event)">
    <mat-error *ngIf="form.hasError('email') && !form.hasError('required')" i18n="@@ErrorMessageIncorectEmail">E-mail isn't valid</mat-error>
    <mat-error *ngIf="form.hasError('required')" i18n="@@ErrorMessageRequired">Required</mat-error>
  </mat-form-field>
</ng-container>
